






import { Vue, Prop, Component } from 'vue-property-decorator';
import { getIdFromURL } from 'vue-youtube-embed';
@Component
export default class VideoPlayer extends Vue {
  @Prop({ default: '' }) url;
  get isYoutubeVideo() {
    return this.url.includes('youtube.com');
  }
  get isVimeoVideo() {
    return this.url.includes('vimeo.com');
  }
  get getVideoId() {
    if (this.isYoutubeVideo) {
      return getIdFromURL(this.url);
    } else if (this.isVimeoVideo) {
      const regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
      const match = this.url.match(regExp);
      return (match && match[2]) || '';
    }
  }
}
